module.exports = __webpack_public_path__ + "img/Fachmann_Gesundheit.519c85fc.jpg";